import React from 'react';

import { FIELD_PATHS } from '@funnels/constants';
import { IncomeEntityIndex } from '@funnels/types';

import { DollarInputField, NumeralDisplay } from '../../Fields';
import { CommonFieldProps } from '../../Fields/_common/types';
import { EditableViewProps, FunnelViewProps, NumericalReadOnlyViewProps } from '../types';

interface IncomeAmountEditableViewProps extends EditableViewProps, IncomeEntityIndex {
  disableFailMessage?: boolean;
  isOptional?: boolean;
}
export function IncomeAmountEditableView(props: IncomeAmountEditableViewProps) {
  const { incomeIndex, ...rest } = props;

  return <DollarInputField {...rest} name={FIELD_PATHS.INCOME_AMOUNT(incomeIndex)} />;
}

interface IncomeAmountFunnelViewProps extends IncomeEntityIndex, FunnelViewProps, Omit<CommonFieldProps, 'name'> {}

export function IncomeAmountFunnelView(props: IncomeAmountFunnelViewProps) {
  const { incomeIndex, ...rest } = props;
  return <DollarInputField {...rest} name={FIELD_PATHS.INCOME_AMOUNT(incomeIndex)} isFullWidth />;
}

export const IncomeAmountFunnelReadOnlyView = (props: NumericalReadOnlyViewProps) => (
  <NumeralDisplay before={'$'} {...props} />
);
